import { render, staticRenderFns } from "./EndGameNotification.vue?vue&type=template&id=54a8ca09&scoped=true&"
import script from "./EndGameNotification.vue?vue&type=script&lang=js&"
export * from "./EndGameNotification.vue?vue&type=script&lang=js&"
import style0 from "./EndGameNotification.vue?vue&type=style&index=0&id=54a8ca09&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a8ca09",
  null
  
)

export default component.exports